'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var Show = function () {
  var Controller = Marionette.Object.extend({
    initialize: function () {
      var self = this

      var LoginModel = Backbone.Model.extend({
        defaults: {
          email: '',
          password: '',
          warning: ''
        },
        validation: {
          email: {
            required: true,
            pattern: 'email'
          },
          password: {
            required: true
          }
        },
        initialize: function () {
        }
      })

      _.extend(LoginModel.prototype, Backbone.Validation.mixin)

      var loginModel = new LoginModel()
      self.layout = self.getLayoutView(loginModel)

      this.listenTo(self.layout, 'form:submit', _.bind(this.formSubmit, this))

      App.rootLayout.showChildView('mainRegion', self.layout)
    },
    /* Helpers --------------------------------------------------------- */
    generateWarningMessage: function (warning) {
      if (!warning) return false
      var title = ''
      switch (warning.name) {
        case 'NotAuthenticated':
          title = "Couldn't login, please check your credentials."
          break
      }

      return {
        'title': title,
        'details': [warning.message]
      }
    },
    /* Event methods --------------------------------------------------------- */
    formSubmit: function (view) {
      var self = this
      view.options.model.set('warning', '')

      var data = Backbone.Syphon.serialize(view)
      var email = data.email.trim()
      var password = data.password.trim()
      view.options.model.set('email', email)
      view.options.model.set('password', password)

      // model validation
      if (!view.options.model.isValid(true)) {
        var validationResult = view.options.model.validate()
        view.options.model.set('warning', {
          'title': "We've encountered some errors",
          'details': _.values(validationResult)
        })
        self.layout.render()
        return
      }

      App.session.login({
        email: email,
        password: password
      }, function (err, result) {
        if (err) {
          view.options.model.set('warning', self.generateWarningMessage(err))
          self.layout.render()
          return
        }

        App.globalChannel.trigger('app:bootstrap')
      })
    },
    /* Views ----------------------------------------------------------------- */
    getLayoutView: function (model) {
      return new View.Layout({model: model})
    }
  })

  return new Controller()
}

module.exports = Show



// WEBPACK FOOTER //
// ./js/modules/page-login/show/index.js